import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';

export const usePages = () => {
  return useSelector((state: RootState) => {
    return state.questionnaire.config
      ? Object.keys(state.questionnaire.config.pages)
      : [];
  });
};

export const useQuestionnairePages = () => {
  const pages = usePages();
  const currentPage = useSelector(
    (state: RootState) => state.graph.currentPage,
  );

  const currentPageIndex = useMemo(
    () => pages.indexOf(currentPage),
    [pages, currentPage],
  );

  const isFirstPage = useMemo(() => currentPageIndex === 0, [currentPageIndex]);

  const isLastPage = useMemo(
    () => currentPageIndex !== -1 && currentPageIndex === pages.length - 1,
    [currentPageIndex, pages.length],
  );

  return {
    pages,
    isFirstPage,
    isLastPage,
  };
};
